import React, { useState } from 'react'
import { StyleSheet, TouchableWithoutFeedback, View } from 'react-native'
import { Avatar, Surface, Text } from 'react-native-paper'

const Instructions = ({ visible, instructions }) => {
  if (!visible) return null

  return (
    <View style={styles.instructions}>
      <Text style={{ fontSize: 18 }}>{instructions}</Text>
    </View>
  )
}

const Step = ({ title, instructions }) => {
  const [visible, setVisible] = useState(true)

  return (
    <Surface style={styles.container} elevation={0}>
      <TouchableWithoutFeedback onPress={() => setVisible(!visible)}>
        <View>
          <View style={styles.header}>
            <Text style={styles.headerText}>{title}</Text>
            <Avatar.Icon
              size={24}
              icon={visible ? 'chevron-up' : 'chevron-down'}
            />
          </View>

          <Instructions {...{ visible, instructions }} />
        </View>
      </TouchableWithoutFeedback>
    </Surface>
  )
}

const StepsAccordion = ({ steps }) =>
  steps.map((item, index) => <Step key={`step-${index}`} {...item} />)

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'transparent',
    borderColor: '#686a70',
    borderTopWidth: 2,
    borderBottomWidth: 0,
    paddingVertical: 15,
    paddingHorizontal: 15,
  },
  header: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  headerText: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  instructions: {
    paddingVertical: 20,
  },
})

export default StepsAccordion
